import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { MobileTab } from '@ge/models/constants';

const TABS = { Sites: 'site', Assets: 'asset' };
const Tab = styled.button`
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  font-size: 16px;
  font-family: 'Museo Sans';
  color: ${(props) => props.theme.entityDetails.siteHeaderIconColor};
  text-align: center;
  font-weight: bold;
  border-bottom: ${(props) => (props.active ? '3px solid #95c8d0' : '3px solid #d9d9d9')};
  transition: background-color 0.5s ease-in-out;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 0px 50px;
  grid-gap: 5px;
`;

export const Tabs = ({ onChangeHandler, active, i18nReady, translateFn }) => {
  const getActive = active === MobileTab.TURBINE ? 'asset' : active;
  return (
    <Grid>
      {Object.keys(TABS).map((tab, index) => (
        <Tab
          key={`${index}-${tab}`}
          disabled={TABS[tab] === MobileTab.ASSET}
          onClick={(e) => onChangeHandler(e, TABS[tab])}
          active={getActive === TABS[tab]}
          id={index}
        >
          {i18nReady && translateFn(`general:mobile.${TABS[tab]}s`, tab)}
        </Tab>
      ))}
    </Grid>
  );
};

Tabs.propTypes = {
  active: PropTypes.string,
  onChangeHandler: PropTypes.func,
  translateFn: PropTypes.func.isRequired,
  i18nReady: PropTypes.bool,
};

Tabs.defaultProps = {
  onChangeHandler: () => null,
  active: 'site',
};
